module.exports = __webpack_public_path__ + "img/Mada_Logo.3bd92650.svg";